import React from 'react';
import SiteForgotPasswordForm from 'containers/SiteForgotPasswordForm';
import SiteFlashes from 'containers/SiteFlashes';
import Card from 'components/general/Card/Card';

const ForgotPassword = () => (
  <div className="island">
    <div className="island__box">
      <Card>
        <Card.Section>
          <SiteFlashes />
          <h1>Reset your password</h1>
          <p>Enter your email and we&#39;ll send you a link to reset your password.</p>
          <SiteForgotPasswordForm />
        </Card.Section>
      </Card>
    </div>
  </div>
);

export default ForgotPassword;
